module.exports = __webpack_public_path__ + "img/global-not_search_content.png?30114f12";